import { render, staticRenderFns } from "./NutritionForm.vue?vue&type=template&id=402b9e6e"
import script from "./NutritionForm.vue?vue&type=script&lang=ts"
export * from "./NutritionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports